import axios from '@/axios'

const state = {}

const getters = {}

const mutations = {}

const actions = {
  addTeamMember({}, teammember) {
    return axios.post(`/team-members`, teammember).then(response => {
      return response.data
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
